import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { MATERIAL_TYPES_FEATURE_KEY } from './keys';
import { materialTypesReducer } from './reducers/material-types.reducer';
import { MaterialTypesEffects } from './effects/material-types.effects';

export function provideMaterialTypesStore(): EnvironmentProviders[] {
    return [provideState(MATERIAL_TYPES_FEATURE_KEY, materialTypesReducer), provideEffects(MaterialTypesEffects)];
}
